import { render } from "./NavSectionMain.vue?vue&type=template&id=18cb12d7"
import script from "./NavSectionMain.vue?vue&type=script&lang=js"
export * from "./NavSectionMain.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__